<template>
    <div class="flex-center position-ref full-height">
        <help-modal/>
        <div class="row">
            <div class="col-lg-8">

                <div class="ibox-title ibox-grey">
                    <h4>{{__('document_template')}}</h4>
                    <button-open-help-modal :help-name="'PMD-001'"/>
                </div>
                <div class="ibox document-editor">

                    <div class="ibox form">

                        <div class="ibox-content">
                            <div class="form-group row m-b-sm basic-form">

                                <div :class="'col-md-2' + ((this.validation_message_document_overlays_id)?' has-error':'')">
                                    <label>{{ __('overlay') }}*</label>
                                    <select class="select2 form-control" name="document_overlays_id" :readonly="disabled_inputs.includes('document_overlays_id')" >
                                        <option></option>
                                        <option v-for="(overlay, index) in overlays_to_select" :value="overlay.id" :selected="form_document_overlays_id == overlay.id" @click="overlayChange(overlay.id)">{{overlay.name}}</option>
                                    </select>
                                    <span class="help-block text-danger">{{this.validation_message_document_overlays_id}}</span>
                                </div>

                                <div :class="'col-md-3' + ((this.validation_message_document_types_id)?' has-error':'')">
                                    <label>{{ __('document_type') }}*</label>
                                    <select class="select2 form-control" name="document_types_id" @change="variablesByType($event.target.value);" :readonly="disabled_inputs.includes('document_types_id')">
                                        <option></option>
                                        <option v-for="(document_type, index) in document_types_to_select" :value="document_type.id" :selected="form_document_types_id == document_type.id">{{document_type.name}}</option>
                                    </select>
                                    <span class="help-block text-danger">{{this.validation_message_document_types_id}}</span>
                                </div>

                                <div :class="'col-md-2' + ((this.validation_message_currency)?' has-error':'')" :style="(this.show_currency_field)?'display:block':'display:none'">
                                    <label>{{ __('currency') }}*</label><br>
                                    <select class="select2 form-control" name="currency" :readonly="disabled_inputs.includes('currency')">
                                        <option></option>
                                        <option value="pln" :selected="this.form_currency == 'pln'">{{ pln_label }}</option>
                                        <option value="foreign" :selected="this.form_currency == 'foreign'">{{ foreign_label }}</option>
                                    </select>
                                    <span class="help-block text-danger">{{this.validation_message_currency}}</span>
                                </div>

                                <div class="col-md-2">
                                    <label>{{ __('translation_language') }}</label><br>
                                    <select class="select2 form-control" name="translation_language" :readonly="disabled_inputs.includes('translation_language')">
                                        <option :value="null">---</option>
                                        <option v-for="(item, index) in translationsToSelect" :value="index" :selected="form_translation_language == index">{{item.label}} ({{index.toUpperCase()}}) </option>
                                    </select>
                                </div>

                                <div :class="'col-md-3' + ((this.validation_message_name_obj)?' has-error':'')">
                                    <label>{{ __('template_name') }}*</label>
                                    <input type="text" class="form-control" name="name_obj" :value="this.name_obj" @change="changeNameObj($event.target.value)" :readonly="disabled_inputs.includes('name_obj')">
                                    <span class="help-block text-danger">{{this.validation_message_name_obj}}</span>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div class="ibox-content">

                        <div v-for="(template_section, index) in template_sections" class="section-item">

                            <div class="m-b item" :data-index="index">
                                <input type="hidden" :name="'sections['+index+'][type]'" :value="template_section.type">

                                <input type="hidden" :value="template_section.column1" class="section_input_column1" :name="'sections['+index+'][column1]'">
                                <input type="hidden" :value="template_section.column1_border" :name="'sections['+index+'][column1_border]'">
                                <input type="hidden" :value="template_section.column2" class="section_input_column2" :name="'sections['+index+'][column2]'">
                                <input type="hidden" :value="template_section.column2_border" :name="'sections['+index+'][column2_border]'">
                                <input type="hidden" :value="template_section.column3" :name="'sections['+index+'][column3]'">
                                <input type="hidden" :value="template_section.column3_border" :name="'sections['+index+'][column3_border]'">
                                <input type="hidden" :value="template_section.goods_services" :name="'sections['+index+'][goods_services]'">
                                <input type="hidden" :value="template_section.goods_services_border" :name="'sections['+index+'][goods_services_border]'">
                                <input type="hidden" :value="template_section.goods_services_text" :name="'sections['+index+'][goods_services_text]'">
                                <input type="hidden" :value="template_section.goods_services_text_border" :name="'sections['+index+'][goods_services_text_border]'">
                                <input type="hidden" :value="template_section.background_color" :name="'sections['+index+'][background_color]'">
                                <input type="hidden" :value="template_section.border_color" :name="'sections['+index+'][border_color]'">
                                <input type="hidden" :value="template_section.border_top" :name="'sections['+index+'][border_top]'">
                                <input type="hidden" :value="template_section.border_bottom" :name="'sections['+index+'][border_bottom]'">
                                <input type="hidden" :value="template_section.border_left" :name="'sections['+index+'][border_left]'">
                                <input type="hidden" :value="template_section.border_right" :name="'sections['+index+'][border_right]'">
                                <input type="hidden" :value="template_section.column1_background_color" :name="'sections['+index+'][column1_background_color]'">
                                <input type="hidden" :value="template_section.column1_border_color" :name="'sections['+index+'][column1_border_color]'">
                                <input type="hidden" :value="template_section.column1_border_top" :name="'sections['+index+'][column1_border_top]'">
                                <input type="hidden" :value="template_section.column1_border_bottom" :name="'sections['+index+'][column1_border_bottom]'">
                                <input type="hidden" :value="template_section.column1_border_left" :name="'sections['+index+'][column1_border_left]'">
                                <input type="hidden" :value="template_section.column1_border_right" :name="'sections['+index+'][column1_border_right]'">
                                <input type="hidden" :value="template_section.column2_background_color" :name="'sections['+index+'][column2_background_color]'">
                                <input type="hidden" :value="template_section.column2_border_color" :name="'sections['+index+'][column2_border_color]'">
                                <input type="hidden" :value="template_section.column2_border_top" :name="'sections['+index+'][column2_border_top]'">
                                <input type="hidden" :value="template_section.column2_border_bottom" :name="'sections['+index+'][column2_border_bottom]'">
                                <input type="hidden" :value="template_section.column2_border_left" :name="'sections['+index+'][column2_border_left]'">
                                <input type="hidden" :value="template_section.column2_border_right" :name="'sections['+index+'][column2_border_right]'">
                                <input type="hidden" :value="template_section.column3_background_color" :name="'sections['+index+'][column3_background_color]'">
                                <input type="hidden" :value="template_section.column3_border_color" :name="'sections['+index+'][column3_border_color]'">
                                <input type="hidden" :value="template_section.column3_border_top" :name="'sections['+index+'][column3_border_top]'">
                                <input type="hidden" :value="template_section.column3_border_bottom" :name="'sections['+index+'][column3_border_bottom]'">
                                <input type="hidden" :value="template_section.column3_border_left" :name="'sections['+index+'][column3_border_left]'">
                                <input type="hidden" :value="template_section.column3_border_right" :name="'sections['+index+'][column3_border_right]'">
                                <input type="hidden" :value="template_section.out_background_color" :name="'sections['+index+'][out_background_color]'">
                                <input type="hidden" :value="template_section.out_border_color" :name="'sections['+index+'][out_border_color]'">
                                <input type="hidden" :value="template_section.out_border_top" :name="'sections['+index+'][out_border_top]'">
                                <input type="hidden" :value="template_section.out_border_bottom" :name="'sections['+index+'][out_border_bottom]'">
                                <input type="hidden" :value="template_section.out_border_left" :name="'sections['+index+'][out_border_left]'">
                                <input type="hidden" :value="template_section.out_border_right" :name="'sections['+index+'][out_border_right]'">
                                <input type="hidden" :value="template_section.table_border_color" :name="'sections['+index+'][table_border_color]'">
                                <input type="hidden" :value="template_section.table_font_color" :name="'sections['+index+'][table_font_color]'">
                                <input type="hidden" :value="template_section.font_color" :name="'sections['+index+'][font_color]'">

                                <div class="col-12">
                                    <div class="editor-section-row">
                                        <span v-html="__(template_section.name)"></span>
                                        <a class="move move-up" v-tooltip="__('move_up')" @click="up(index)" :disabled="index==0">
                                            <i class="fa fa-arrow-up"></i>
                                        </a>
                                        <a class="move move-down" v-tooltip="__('move_down')" @click="down(index)" :disabled="index==(template_sections.length-1)">
                                            <i class="fa fa-arrow-down"></i>
                                        </a>
                                        <a href="#" class="tooltip-more icon-delete2" v-tooltip="__('delete')" v-on:click="setDeleteSwal();index_to_remove=index"><i class="fa fa-trash"></i></a>
                                    </div>
                                </div>

                                <div class="col-lg-12" v-if="template_section.type=='whole_width'">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column1')">
                                                <div class="column1" v-html="template_section.column1"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column1')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-if="template_section.type=='2columns'">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column1')">
                                                <div class="column1" v-html="template_section.column1"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column1')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column2')">
                                                <div class="column2" v-html="template_section.column2"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column2')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12" v-if="template_section.type=='3columns'">
                                    <div class="row">
                                        <div class="col-4">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column1')">
                                                <div class="column1" v-html="template_section.column1"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column1')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>

                                        <div class="col-4">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column2')">
                                                <div class="column2" v-html="template_section.column2"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column2')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>

                                        <div class="col-4">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'column3')">
                                                <div class="column3" v-html="template_section.column3"></div>
                                                <a v-on:click="fillEditSectionModal(index,'column3')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="template_section.type=='goods_services' || template_section.type=='contract' || template_section.type=='goods_services_advance_final' || template_section.type=='goods_services_advance_indirect_in_xxx' || template_section.type=='goods_services_margin_final'">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div :class="'editor-section border'+(template_section.goods_services_border?1:0)" :style="setBorderStyle(template_section, 'out') + 'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                                <div v-if="template_section.type=='contract'"><strong>{{__('contact_order_data')}}:<span class="translation" v-html="getTranslation('contact_order_data')"></span></strong></div>
                                                <em v-if="template_section.goods_services_selected_list.contract_description == 'visible'">[{{__('contact_description_variable')}}]</em>
                                                <div class="table-responsive">
                                                    <table class="invoicetable" :style="'border-color:'+((template_section.table_border_color)?template_section.table_border_color:'#000')">
                                                        <tr>
                                                            <th v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">{{__('symbol')}}<span class="translation" v-html="getTranslation('symbol')"></span></th>
                                                            <th class="good_or_service_name">{{__('good_or_service_name')}}<span class="translation" v-html="getTranslation('good_or_service_name')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">{{__('pkwiu')}}</th>
                                                            <th>{{__('item_quantity')}}<span class="translation" v-html="getTranslation('item_quantity')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.jm_column == 'visible'">{{__('jm')}}<span class="translation" v-html="getTranslation('jm')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">{{__('price_before_discount')}}<span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('price_before_discount')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">{{__('discount%')}}<span class="translation" v-html="getTranslation('discount%')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">
                                                                {{__((billMode == true)?'price_after_discount':'price_net_gross_after_discount')}}
                                                                <span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span>
                                                                <span class="translation" v-html="getTranslation((billMode == true)?'price_after_discount':'price_net_gross_after_discount')"></span>
                                                            </th>
                                                            <th v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">
                                                                {{__((billMode == true)?'price':'price_net_gross')}}
                                                                <span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span>
                                                                <span class="translation" v-html="getTranslation((billMode == true)?'price':'price_net_gross')"></span>
                                                            </th>
                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">{{__('document_net_amount')}}<span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>

                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' & billMode == false">{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">
                                                                <span v-if="billMode == true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">
                                                                    {{__('value')}}
                                                                    <span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('value')"></span>
                                                                </span>
                                                                <span v-if="billMode != true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">
                                                                    {{__('document_net_amount')}}
                                                                    <span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('document_net_amount')"></span>
                                                                </span>
                                                                <span v-if="billMode != true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">
                                                                    {{__('gross_net_value')}}
                                                                    <span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('gross_net_value')"></span>
                                                                </span>
                                                            </th>

                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">{{__('item_vat_amount')}}<span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                            <th v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">{{__('gross_amount')}}<span v-if="foreign_currency & billMode == false"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                        </tr>
                                                        <tbody v-for="index in 2" :key="index">
                                                            <tr>
                                                                <td v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{index}}</td>
                                                                <td v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">[{{__('symbol')}}]</td>
                                                                <td class="text-left">[{{__('good_or_service_name')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">[{{__('pkwiu')}}]</td>
                                                                <td>[{{__('item_quantity')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.jm_column == 'visible'">[{{__('jm')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price_before_discount')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">[{{__('discount%')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">[{{__('price')}}]</td>

                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">[{{__('document_net_amount')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">[{{__('item_vat_rate')}}]</td>

                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' & billMode == false">[{{__('item_vat_rate')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">
                                                                    <span v-if="billMode == true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">[{{__('value')}}]</span>
                                                                    <span v-if="billMode != true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">[{{__('document_net_amount')}}]</span>
                                                                    <span v-if="billMode != true & template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible'">[{{__('document_net_amount')}}][{{__('gross_amount')}}]</span>
                                                                </td>

                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">[{{__('item_vat_amount')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible'">[{{__('gross_amount')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td :colspan="template_section.goods_services_colspan_counter" style="text-align:left">{{__('good_or_service_description_variable')}}</td>
                                                            </tr>
                                                        </tbody>

                                                        <tr v-if="(template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency) & billMode == false">
                                                            <td :colspan="template_section.goods_services_colspan_counter" class="no-border-left no-border-bottom no-border-right">&nbsp;</td>
                                                        </tr>
                                                        <tr class="keep_height">
                                                            <td :rowspan="(template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency)?5:4" :colspan="(billMode == false)?template_section.goods_services_colspan_counter2:(template_section.goods_services_colspan_counter2+2)" :class="'text-left v-top no-border-left no-border-bottom no-border-right no-border-top pl0'+(((template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency) & billMode == false)?' pt0':'')">
                                                                <div v-if="template_section.type=='goods_services' | template_section.type=='contract' | template_section.type=='goods_services_advance_indirect_in_xxx'" class="p10 border0" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color">
                                                                    <div v-html="template_section.goods_services_text" class="gs-text">

                                                                    </div>
                                                                    <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                </div>
                                                            </td>

                                                            <td class="no-border-bottom no-border-top no-border-right text-right uppercase" v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible' & !foreign_currency & billMode == false" v-html="__('total') + getTranslation('total')"></td>
                                                            <td v-if="billMode == false" v-html="((template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency)?__('rate') + getTranslation('rate'):'')+'<span style=\'background-color:'+template_section.table_border_color+';\'></span>'" class="no-border-left border-left2"></td>
                                                            <td v-if="billMode == false" v-html="(template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency)?__('net')+((foreign_currency)?' '+__('in_xxx_currency_example_label'):'') + getTranslation('net'):'X'"></td>
                                                            <td v-if="billMode == false" v-html="(template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency)?__('vat')+((foreign_currency)?' '+__('in_pln_currency_example_label'):'') + getTranslation('vat'):''"></td>
                                                            <td v-if="billMode == false" v-html="(template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible' | foreign_currency)?__('gross')+((foreign_currency)?' '+__('in_xxx_currency_example_label'):'') + getTranslation('gross'):''"></td>

                                                            <td v-if="billMode == true" class="no-border-left no-border-bottom no-border-left text-right">
                                                                {{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span>:
                                                                <span :style="'background-color:'+template_section.table_border_color"></span>
                                                            </td>
                                                            <td v-if="billMode == true"></td>

                                                        </tr>
                                                        <tr class="keep_height" v-if="billMode == false">
                                                            <td class="no-border-bottom no-border-top no-border-right text-right" v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible' & !foreign_currency" v-html="__('including') + getTranslation('including')"></td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible' & !foreign_currency & billMode == false">
                                                            <td class="no-border-top no-border-right"></td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="((template_section.goods_services_selected_list.vat_amount_and_gross_value_columns != 'visible') | foreign_currency) & billMode == false">
                                                            <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible' & !foreign_currency" class="no-border-left no-border-bottom no-border-top no-border-right"></td>
                                                            <td>{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span>:</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td v-if="template_section.goods_services_selected_list.vat_amount_and_gross_value_columns == 'visible' & !foreign_currency" class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td v-if="billMode == false" class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td v-if="billMode == false" class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                        </tr>

                                                    </table>
                                                </div>

                                                <div v-if="template_section.type=='goods_services_advance_final'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                                    <div><strong class="uppercase">{{__('billed_advances')}}:<span class="translation" v-html="getTranslation('billed_advances')"></span></strong></div>
                                                    <div class="table-responsive">
                                                        <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                            <tr>
                                                                <th>{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                                <th class="no-border-right">{{__('document_number')}}</th>
                                                                <th class="no-border-left no-border-right"></th>
                                                                <th>{{__('document_net_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                                <th>{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                                <th>{{__('item_vat_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                                <th>{{__('gross_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                            </tr>
                                                            <tbody>
                                                                <tr>
                                                                    <td>1</td>
                                                                    <td class="text-left no-border-right">[{{__('document_number_settled_advance_payment')}}]</td>
                                                                    <td class="no-border-left no-border-right"></td>
                                                                    <td>[{{__('document_net_amount')}}]</td>
                                                                    <td>[{{__('item_vat_rate')}}]</td>
                                                                    <td>[{{__('item_vat_amount')}}]</td>
                                                                    <td>[{{__('gross_amount')}}]</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>2</td>
                                                                    <td class="text-left no-border-right">[{{__('document_number_settled_advance_payment')}}]</td>
                                                                    <td class="no-border-left no-border-right"></td>
                                                                    <td>[{{__('document_net_amount')}}]</td>
                                                                    <td>[{{__('item_vat_rate')}}]</td>
                                                                    <td>[{{__('item_vat_amount')}}]</td>
                                                                    <td>[{{__('gross_amount')}}]</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2" class="no-border-left no-border-right no-border-bottom"></td>
                                                                    <td class="text-right uppercase no-border-left no-border-bottom">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                    <td></td>
                                                                    <td>X</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="13" class="text-left no-border-left no-border-right no-border-bottom no-border-top pl0"><strong class="uppercase">{{__('value_after_accounting_for_billed_advances')}}:<span class="translation" v-html="getTranslation('value_after_accounting_for_billed_advances')"></span></strong></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colspan="2" rowspan="6" class="no-border-left no-border-right no-border-top no-border-bottom text-left">
                                                                        <div v-html="template_section.goods_services_text" class="p10 gs-text" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color"></div>
                                                                        <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="foreign_currency" class="keep_height">
                                                                    <th class="no-border-top no-border-bottom no-border-left"></th>
                                                                    <th>{{__('rate')}}<span class="translation" v-html="getTranslation('rate')"></span></th>
                                                                    <th>{{__('net')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('net')"></span></th>
                                                                    <th>{{__('vat')}} {{__('in_pln_currency_example_label')}}<span class="translation" v-html="getTranslation('vat')"></span></th>
                                                                    <th>{{__('gross')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('gross')"></span></th>
                                                                </tr>
                                                                <tr v-if="foreign_currency" class="keep_height">
                                                                    <td class="no-border-top no-border-bottom no-border-left"></td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                </tr>
                                                                <tr v-if="foreign_currency" class="keep_height">
                                                                    <td class="no-border-top no-border-bottom no-border-left"></td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                </tr>
                                                                <tr v-if="foreign_currency" class="keep_height">
                                                                    <td class="no-border-top no-border-bottom no-border-left"></td>
                                                                    <td>{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span>:</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr v-if="!foreign_currency" class="keep_height">
                                                                    <th class="no-border-left no-border-top no-border-bottom text-right"></th>
                                                                    <th>{{__('document_net_amount')}}<span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                                    <th>{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                                    <th>{{__('item_vat_amount')}}<span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                                    <th>{{__('gross_amount')}}<span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                                </tr>
                                                                <tr v-if="!foreign_currency" class="keep_height">
                                                                    <td class="no-border-left no-border-top no-border-bottom uppercase text-right">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                    <td></td>
                                                                    <td>X</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>

                                                                <tr v-if="!foreign_currency" class="keep_height">
                                                                    <td class="no-border-left no-border-top no-border-bottom text-right">{{__('including')}}:<span class="translation" v-html="getTranslation('including')"></span></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>

                                                                <tr>
                                                                    <td class="no-border-top no-border-bottom no-border-left no-border-right"></td>
                                                                    <td class="no-border-top no-border-bottom no-border-left no-border-right"></td>
                                                                    <td class="no-border-top no-border-bottom no-border-left no-border-right"></td>
                                                                    <td class="no-border-top no-border-bottom no-border-left no-border-right"></td>
                                                                    <td class="no-border-top no-border-bottom no-border-left no-border-right"></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div v-if="template_section.type=='goods_services_margin_final'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                                    <div><strong class="uppercase">{{__('billed_advances')}}:<span class="translation" v-html="getTranslation('billed_advances')"></span></strong></div>

                                                    <div class="table-responsive">
                                                        <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                            <tr>
                                                                <th>{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                                <th class="no-border-right text-center" colspan="2">{{__('document_number')}}<span class="translation" v-html="getTranslation('document_number')"></span></th>
                                                                <th>{{__('value')}}<span class="translation" v-html="getTranslation('value')"></span></th>
                                                            </tr>
                                                            <tr>
                                                                <td>1</td>
                                                                <td class="no-border-right text-left" colspan="2">[{{__('document_number_settled_advance_payment')}}]</td>
                                                                <td>[{{__('value')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td class="no-border-right text-left" colspan="2">[{{__('document_number_settled_advance_payment')}}]</td>
                                                                <td>[{{__('value')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="no-border-right no-border-left no-border-bottom"></td>
                                                                <td class="no-border-right no-border-left no-border-bottom"></td>
                                                                <th class="no-border-bottom no-border-left text-right">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></th>
                                                                <td></td>
                                                            </tr>

                                                            <tr>
                                                                <td colspan="4" class="no-border-right no-border-left no-border-bottom no-border-top">&nbsp;</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4" class="text-left no-border-right no-border-left no-border-bottom no-border-top"><strong class="uppercase">{{__('value_after_accounting_for_billed_advances')}}:<span class="translation" v-html="getTranslation('value_after_accounting_for_billed_advances')"></span></strong></td>
                                                            </tr>

                                                            <tr>
                                                                <td rowspan="4" colspan="2" class="no-border-right no-border-left no-border-bottom no-border-top text-left gs-text">
                                                                    <div v-html="template_section.goods_services_text" class="p10 gs-text" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color"></div>
                                                                    <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                </td>
                                                            </tr>
                                                            <tr class="keep_height">
                                                                <th class="no-border-left no-border-top no-border-bottom"></th>
                                                                <th>{{__('value')}}<span class="translation" v-html="getTranslation('value')"></span></th>
                                                            </tr>
                                                            <tr class="keep_height">
                                                                <td class="uppercase no-border-left no-border-top no-border-bottom text-right">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span>:</td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td class="no-border-left no-border-top no-border-bottom no-border-right"></td>
                                                                <td class="no-border-left no-border-top no-border-bottom no-border-right"></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services', false, true)" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="template_section.type=='goods_services_advance'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'out')">
                                                <div class="table-responsive">
                                                    <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th>{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                            <th class="good_or_service_name">{{__('good_or_service_name')}}<span class="translation" v-html="getTranslation('good_or_service_name')"></span></th>
                                                            <th>{{__('net_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('net_amount')"></span></th>
                                                            <th>{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                            <th>{{__('item_vat_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                            <th>{{__('gross_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                        </tr>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td class="text-left">[{{__('good_or_service_name')}}]</td>
                                                                <td>[{{__('net_amount')}}]</td>
                                                                <td>[{{__('item_vat_rate')}}]</td>
                                                                <td>[{{__('item_vat_amount')}}]</td>
                                                                <td>[{{__('gross_amount')}}]</td>
                                                            </tr>
                                                        </tbody>
                                                        <tr>
                                                            <td :rowspan="(foreign_currency)?6:4" :colspan="(foreign_currency)?2:1" class="no-border-left no-border-bottom no-border-right pl0">
                                                                <div class="p10 text-left border0" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color">
                                                                    <div v-html="template_section.goods_services_text" class="gs-text">

                                                                    </div>
                                                                    <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="foreign_currency">
                                                            <td class="no-border-left no-border-bottom no-border-right no-border-top">&nbsp;</td>
                                                            <td class="no-border-left no-border-bottom no-border-right no-border-top">&nbsp;</td>
                                                            <td class="no-border-left no-border-bottom no-border-right no-border-top">&nbsp;</td>
                                                            <td class="no-border-left no-border-bottom no-border-right no-border-top">&nbsp;</td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="foreign_currency">
                                                            <td>{{__('rate')}}<span class="translation" v-html="getTranslation('rate')"></span></td>
                                                            <td>{{__('net')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('net')"></span></td>
                                                            <td>{{__('vat')}} {{__('in_pln_currency_example_label')}}<span class="translation" v-html="getTranslation('vat')"></span></td>
                                                            <td>{{__('gross')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('gross')"></span></td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="foreign_currency">
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="foreign_currency">
                                                            <td>{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="!foreign_currency">
                                                            <td class="uppercase text-right no-border-left no-border-bottom no-border-top">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                            <td></td>
                                                            <td>X</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr class="keep_height" v-if="!foreign_currency">
                                                            <td class="text-right no-border-left no-border-bottom no-border-top">{{__('including')}}:</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services', true)" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="template_section.type=='before_advances'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'out')">

                                                <div><strong class="uppercase">{{__('before_advances')}}:<span class="translation" v-html="getTranslation('before_advances')"></span></strong></div>

                                                <div class="table-responsive">
                                                    <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th>{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                            <th colspan="8">{{__('document_number')}}<span class="translation" v-html="getTranslation('document_number')"></span></th>
                                                            <th>{{__('document_net_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                            <th>{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                            <th>{{__('item_vat_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                            <th>{{__('gross_amount')}} <span v-if="foreign_currency">{{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                        </tr>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td colspan="8" class="text-left">[{{__('document_number_advance_payment')}}]</td>
                                                                <td>[{{__('document_net_amount')}}]</td>
                                                                <td>[{{__('item_vat_rate')}}]</td>
                                                                <td>[{{__('item_vat_amount')}}]</td>
                                                                <td>[{{__('gross_amount')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td colspan="8" class="text-left">[{{__('document_number_advance_payment')}}]</td>
                                                                <td>[{{__('document_net_amount')}}]</td>
                                                                <td>[{{__('item_vat_rate')}}]</td>
                                                                <td>[{{__('item_vat_amount')}}]</td>
                                                                <td>[{{__('gross_amount')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="4" colspan="8" class="no-border-left no-border-bottom no-border-right pl0">
                                                                    <div class="p10 text-left border0" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color">
                                                                        <div v-html="template_section.goods_services_text" class="gs-text">

                                                                        </div>
                                                                        <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr class="keep_height">
                                                                <td class="uppercase text-right no-border-bottom no-border-left">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                <td></td>
                                                                <td>X</td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="13" class="no-border-left no-border-right no-border-bottom no-border-top">&nbsp;</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services', true)" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="template_section.type=='goods_services_margin_advance'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'out')">
                                                <div class="table-responsive">
                                                    <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th class="w50">{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                            <th class="good_or_service_name">{{__('good_or_service_name')}}<span class="translation" v-html="getTranslation('good_or_service_name')"></span></th>
                                                            <th class="w90">{{__('value')}}<span class="translation" v-html="getTranslation('value')"></span></th>
                                                        </tr>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td class="text-left">[{{__('good_or_service_name')}}]</td>
                                                                <td>[{{__('value')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" class="no-border-left no-border-bottom text-right uppercase">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span>:</td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services', true)" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="template_section.type=='before_advances_margin'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'out')">

                                                <div><strong class="uppercase">{{__('before_advances')}}:<span class="translation" v-html="getTranslation('before_advances')"></span></strong></div>

                                                <div class="table-responsive">
                                                    <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th class="w50">{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                            <th class="text-center">{{__('document_number')}}<span class="translation" v-html="getTranslation('document_number')"></span></th>
                                                            <th class="w90">{{__('value')}}<span class="translation" v-html="getTranslation('value')"></span></th>
                                                        </tr>
                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td class="text-left">[{{__('document_number_advance_payment')}}]</td>
                                                                <td>[{{__('value')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td class="text-left">[{{__('document_number_advance_payment')}}]</td>
                                                                <td>[{{__('value')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-right no-border-left no-border-bottom uppercase" colspan="2">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services', true)" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="template_section.type=='goods_services_correction'" :style="'color:'+((template_section.table_font_color)?template_section.table_font_color:'#000')">
                                    <div class="col-12">
                                        <div class="col-12">
                                            <div class="editor-section" :style="setBorderStyle(template_section, 'out')">
                                                <strong class="uppercase">{{__('document_number_correction')}}</strong><span class="translation" v-html="getTranslation('invoice_number_correction')"></span>
                                                <div class="table-responsive">
                                                    <table class="invoicetable2 " >
                                                        <tr>
                                                            <td class="text-left">
                                                                <span class="text-bold">{{__('document_number_before_correction')}}:</span> [{{__('doc_number_before')}}]
                                                                <span class="translation" v-html="getTranslation('invoice_number_before_correction')"></span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left">
                                                                <span class="text-bold">{{__('document_number_after_correction')}}:</span> [{{__('doc_numer_after')}}]
                                                                <span class="translation" v-html="getTranslation('invoice_number_after_correction')"></span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <hr/>
                                                </div>
                                                <!--                                                        END SECTION-->
                                                <!--                                                        SELLER CORRECTION-->
                                                <strong class="uppercase">{{__('correction_seller_data')}}</strong>
                                                <span class="translation" v-html="getTranslation('seller_data_correction')"></span>
                                                <div class="table-responsive">
                                                    <table class="invoicetable2">
                                                        <tr>
                                                            <td class="text-left">
                                                                <span class="text-bold">{{__('seller_data_before_correction')}}:</span> [{{__('seller_data_before')}}]
                                                                <span class="translation" v-html="getTranslation('seller_data_before_correction')"></span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left">
                                                                   <span class="text-bold">{{__('seller_data_after_correction')}}:</span> [{{__('seller_data_after')}}]
                                                                <span class="translation" v-html="getTranslation('seller_data_after_correction')"></span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <hr/>
                                                </div>
                                                <!--                                                    END SECTION SELLER_DATA-->
                                                <!--                                                    RECEIVER CORRECTION&ndash;&gt;-->
                                                <strong class="uppercase">{{__('correction_receiver_data')}}</strong>
                                                <span class="translation" v-html="getTranslation('buyer_data_correction')"></span>
                                                <div class="table-responsive">
                                                    <table class="invoicetable2 ">
                                                        <tr>
                                                            <td class="text-left">
                                                                <span class="text-bold">{{__('receiver_data_before_correction')}}:</span> [{{__('receiver_data_before')}}]
                                                                <span class="translation" v-html="getTranslation('buyer_data_before_correction')"></span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left">
                                                                   <span class="text-bold">{{__('receiver_data_after_correction')}}:</span> [{{__('receiver_data_after')}}]
                                                                <span class="translation" v-html="getTranslation('buyer_data_after_correction')"></span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <hr/>
                                                </div>
                                                <!--                                                    END SECTION RECEIVER_DATA-->
                                                <!--                                                            CONTRACT DESCRIPTION-->
                                                <strong class="uppercase">{{__('correction_contract_description')}}</strong>
                                                <span class="translation" v-html="getTranslation('contract_description_correction')"></span>
                                                <div class="table-responsive">
                                                    <table class="invoicetable2 " >
                                                        <tr>
                                                            <td class=" text-left">
                                                                   <span class="text-bold">{{__('after_correction')}}:</span>
                                                                <span class="translation" v-html="getTranslation('contract_description_after_correction')"></span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left">
                                                                [{{__('corrected_contract_description')}}]
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <hr/>
                                                </div>
                                                <strong class="uppercase">{{ __('correction_contract_value') }}</strong>
                                                <span class="translation" v-html="getTranslation('subject_and_contract_value_correction')"></span>
                                                <div v-for="base_index in 2" :key="base_index">

                                                    <strong class="">{{__((base_index==1)?'before_correction':'after_correction')}}:</strong>
                                                    <span class="translation" v-html="getTranslation((base_index==1)?'before_correction':'after_correction')"></span>
                                                    <div class="table-responsive">
                                                        <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                            <tr>
                                                                <th v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">{{__('symbol')}}<span class="translation" v-html="getTranslation('symbol')"></span></th>
                                                                <th class="good_or_service_name">{{__('good_or_service_name')}}<span class="translation" v-html="getTranslation('good_or_service_name')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">{{__('pkwiu')}}</th>
                                                                <th>{{__('item_quantity')}}<span class="translation" v-html="getTranslation('item_quantity')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.jm_column == 'visible'">{{__('jm')}}<span class="translation" v-html="getTranslation('jm')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">{{__('price_before_discount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('price_before_discount')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">{{__('discount%')}}<span class="translation" v-html="getTranslation('discount%')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">
                                                                    {{__('price_net_gross_after_discount')}}
                                                                    <span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('price_net_gross_after_discount')"></span>
                                                                </th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">
                                                                    {{__('price_net_gross')}}
                                                                    <span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('price_net_gross')"></span>
                                                                </th>
                                                                <th class="w70">{{__('document_net_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                                <th class="w70">{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                                <th class="w70">{{__('item_vat_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                                <th class="w70">{{__('gross_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                            </tr>
                                                            <tbody v-for="index in 2" :key="index">
                                                            <tr>
                                                                <td v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{index}}</td>
                                                                <td v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">[{{__('symbol')}}]</td>
                                                                <td class="text-left">[{{__('good_or_service_name')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">[{{__('pkwiu')}}]</td>
                                                                <td>[{{__('item_quantity')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.jm_column == 'visible'">[{{__('jm')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price_before_discount')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">[{{__('discount%')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price')}}]</td>
                                                                <td v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">[{{__('price')}}]</td>
                                                                <td>[{{__('document_net_amount')}}]</td>
                                                                <td>[{{__('item_vat_rate')}}]</td>
                                                                <td>[{{__('item_vat_amount')}}]</td>
                                                                <td>[{{__('gross_amount')}}]</td>
                                                            </tr>
                                                            <tr>
                                                                <td :colspan="template_section.goods_services_colspan_counter" style="text-align:left">{{__('good_or_service_description_variable')}}</td>
                                                            </tr>
                                                            </tbody>
                                                            <tr class="keep_height">
                                                                <td rowspan="2" :colspan="template_section.goods_services_colspan_counter2" class="text-left v-top no-border-left no-border-bottom no-border-right no-border-top pl0">
<!--                                                                    <div v-if="base_index == 2" class="p10 border0" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color">-->
<!--                                                                        <div v-html="template_section.goods_services_text" class="gs-text">-->

<!--                                                                        </div>-->
<!--                                                                        <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>-->
<!--                                                                    </div>-->
                                                                </td>

                                                                <td class="no-border-bottom no-border-top no-border-right no-border-left text-right uppercase">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                <td></td>
                                                                <td>X</td>
                                                                <td></td>
                                                                <td></td>

                                                            </tr>
                                                            <tr>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            </tr>

                                                        </table>
                                                    </div>

                                                </div>
                                                <strong class="">{{ __('document_value_correction') }}</strong>
                                                <span class="translation" v-html="getTranslation('subject_and_invoice_value_correction')"></span>
                                                <div v-for="base_index in 2" :key="base_index">

                                                    <strong class="">{{__((base_index==1)?'before_correction':'after_correction')}}:</strong>
                                                    <span class="translation" v-html="getTranslation((base_index==1)?'before_correction':'after_correction')"></span>
                                                    <div class="table-responsive">
                                                        <table class="invoicetable" :style="'border-color:'+template_section.table_border_color">
                                                            <tr>
                                                                <th v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{__('lp')}}<span class="translation" v-html="getTranslation('lp')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">{{__('symbol')}}<span class="translation" v-html="getTranslation('symbol')"></span></th>
                                                                <th class="good_or_service_name">{{__('good_or_service_name')}}<span class="translation" v-html="getTranslation('good_or_service_name')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">{{__('pkwiu')}}</th>
                                                                <th>{{__('item_quantity')}}<span class="translation" v-html="getTranslation('item_quantity')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.jm_column == 'visible'">{{__('jm')}}<span class="translation" v-html="getTranslation('jm')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">{{__('price_before_discount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('price_before_discount')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">{{__('discount%')}}<span class="translation" v-html="getTranslation('discount%')"></span></th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">
                                                                    {{__('price_net_gross_after_discount')}}
                                                                    <span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('price_net_gross_after_discount')"></span>
                                                                </th>
                                                                <th v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">
                                                                    {{__('price_net_gross')}}
                                                                    <span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span>
                                                                    <span class="translation" v-html="getTranslation('price_net_gross')"></span>
                                                                </th>
                                                                <th class="w70">{{__('document_net_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                                <th class="w70">{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                                <th class="w70">{{__('item_vat_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                                <th class="w70">{{__('gross_amount')}}<span v-if="foreign_currency"> {{__('in_xxx_currency_example_label')}}</span><span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                            </tr>
                                                            <tbody v-for="index in 2" :key="index">
                                                                <tr>
                                                                    <td v-if="template_section.goods_services_selected_list.lp_column == 'visible'">{{index}}</td>
                                                                    <td v-if="template_section.goods_services_selected_list.symbol_column == 'visible'">[{{__('symbol')}}]</td>
                                                                    <td class="text-left">[{{__('good_or_service_name')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.pkwiu_column == 'visible'">[{{__('pkwiu')}}]</td>
                                                                    <td>[{{__('item_quantity')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.jm_column == 'visible'">[{{__('jm')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price_before_discount')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise' | template_section.goods_services_selected_list.information_about_discounts == 'simplified'">[{{__('discount%')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.information_about_discounts == 'precise'">[{{__('price')}}]</td>
                                                                    <td v-if="template_section.goods_services_selected_list.information_about_discounts != 'precise'">[{{__('price')}}]</td>
                                                                    <td>[{{__('document_net_amount')}}]</td>
                                                                    <td>[{{__('item_vat_rate')}}]</td>
                                                                    <td>[{{__('item_vat_amount')}}]</td>
                                                                    <td>[{{__('gross_amount')}}]</td>
                                                                </tr>
                                                                <tr>
                                                                    <td :colspan="template_section.goods_services_colspan_counter" style="text-align:left">{{__('good_or_service_description_variable')}}</td>
                                                                </tr>
                                                            </tbody>
                                                            <tr class="keep_height">
                                                                <td rowspan="2" :colspan="template_section.goods_services_colspan_counter2" class="text-left v-top no-border-left no-border-bottom no-border-right no-border-top pl0">
                                                                    <div v-if="base_index == 2" class="p10 border0" :style="setBorderStyle(template_section, 'goods_services_text')+';color:'+template_section.font_color">
                                                                        <div v-html="template_section.goods_services_text" class="gs-text">

                                                                        </div>
                                                                        <a v-on:click="fillEditSectionModal(index,'goods_services_text')" href="#" class="btn btn-default btn-xs m-t-xs" data-toggle="modal" data-target="#editSection"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                                    </div>
                                                                </td>

                                                                <td class="no-border-bottom no-border-top no-border-right no-border-left text-right uppercase">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                                <td></td>
                                                                <td>X</td>
                                                                <td></td>
                                                                <td></td>

                                                            </tr>
                                                            <tr>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                                <td class="no-border-left no-border-right no-border-bottom no-border-top emptyrow"></td>
                                                            </tr>

                                                        </table>
                                                    </div>

                                                </div>

                                                <div class="col-lg-12">&nbsp;</div>

                                                <div class="table-responsive">
                                                    <table class="invoicetable" v-if="!foreign_currency" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th class="no-border-left no-border-top no-border-bottom"></th>
                                                            <th class="w70">{{__('document_net_amount')}}<span class="translation" v-html="getTranslation('document_net_amount')"></span></th>
                                                            <th class="w70">{{__('item_vat_rate')}}<span class="translation" v-html="getTranslation('item_vat_rate')"></span></th>
                                                            <th class="w70">{{__('item_vat_amount')}}<span class="translation" v-html="getTranslation('item_vat_amount')"></span></th>
                                                            <th class="w70">{{__('gross_amount')}}<span class="translation" v-html="getTranslation('gross_amount')"></span></th>
                                                        </tr>
                                                        <tr>
                                                            <td class="uppercase no-border-left no-border-top text-right no-border-bottom">{{__('correction_amount')}}:<span class="translation" v-html="getTranslation('correction_amount')"></span></td>
                                                            <td class="w70"></td>
                                                            <td class="w70">X</td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="no-border-left no-border-top text-right no-border-bottom">{{__('including')}}:<span class="translation" v-html="getTranslation('including')"></span></td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                        </tr>
                                                    </table>
                                                    <table class="invoicetable" v-if="foreign_currency" :style="'border-color:'+template_section.table_border_color">
                                                        <tr>
                                                            <th class="no-border-left no-border-bottom no-border-top"></th>
                                                            <th class="w70">{{__('rate')}}<span class="translation" v-html="getTranslation('rate')"></span></th>
                                                            <th class="w70">{{__('net')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('net')"></span></th>
                                                            <th class="w70">{{__('vat')}} {{__('in_pln_currency_example_label')}}<span class="translation" v-html="getTranslation('vat')"></span></th>
                                                            <th class="w70">{{__('gross')}} {{__('in_xxx_currency_example_label')}}<span class="translation" v-html="getTranslation('gross')"></span></th>
                                                        </tr>
                                                        <tr>
                                                            <td class="no-border-left no-border-bottom no-border-top">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="no-border-left no-border-bottom no-border-top">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                            <td class="w70">&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="no-border-left no-border-bottom no-border-top"></td>
                                                            <td class="w70">{{__('total')}} <span class="translation inline" v-html="getTranslation('total')"></span></td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                            <td class="w70"></td>
                                                        </tr>
                                                    </table>
                                                </div>


                                                <div class="clearfix"></div>
                                                <a v-on:click="fillEditSectionGoodsModal(index,'goods_services')" href="#" class="btn btn-default btn-xs m-t-xs float-right" data-toggle="modal" data-target="#editSectionGoods"><i class="fa fa-pen"></i> {{ __('edit') }}</a>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addSection"><i class="fa fa-plus"></i> {{ __('add_section') }}</a>
                                <button id="preview" class="btn btn-primary btn-sm"><i class="fa fa-eye"></i> {{ __('preview') }}</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="ibox">
                    <div class="ibox-content">
                        <div class="row" v-if="(mode == 'create' || mode=='copy') && !is_sa">
                            <div class="col-sm-4 col-sm-offset-2">
                                <label class="m-b"><input type="checkbox" v-model="old_activate_template" name="activate">
                                    <strong>{{ __('activate_template') }}</strong>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4 col-sm-offset-2">
                                <a :href="this.document_templates_route" class="btn btn-white btn-sm">{{ __('cancel') }}</a>
                                <button id="submit" :disabled="submit_disabled" type="submit" class="btn btn-primary btn-sm">{{ __((mode=='edit')?'save':'add') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal inmodal fade" id="editSection" tabindex="-1" role="dialog"  aria-hidden="true">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">{{ __('close') }}</span></button>
                                <h3>{{ __('edit_section') }}</h3>
                            </div>
                            <div class="modal-body text-editor">
                                <input type="hidden" name="section_index" v-bind:value="edit_section_modal_index">
                                <input type="hidden" name="section_field" v-bind:value="edit_section_modal_field">
                                <textarea name="value" class="form-control summernote" id="editSectionVal"></textarea>
                            </div>
                            <div class="modal-body">
                                <div class="panel panel-default m-b-sm">
                                    <div class="panel-heading">
                                        <strong>{{ __('available_variables') }}:</strong><br>
                                        <div class="variables_box">
                                            <div class="variables">
                                                <span v-for="(v, index) in variables_arr">
                                                    <span :class="(v.used?'bold':'')+' cp'" @click="getVariableDescription(v.id,v.name,true)" v-if="v.access" v-tooltip="__((v.used?'variable_used_in_template':''))">{{'['+v.name+'], '}}</span>
<!--                                                    <span v-if="!v.access" v-html="'<del>['+v.name+']</del>, '" v-tooltip="__('variable_not_available_for_the_selected_document_type')"></span>-->
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body" style="border-top: 1px solid #e9ecef;">
                                <h3>{{__('the_appearance_of_section')}}</h3>
                                <div class="row m-b-xs m-t">
                                    <div class="col-md-4" style="display:none">
                                        <strong><label>{{__('section_font_color')}}</label></strong>
                                        <div class="color-picker" data-color="5">
                                            <input type="text" class="mini-color form-control" v-model="color5" data-color-no="5">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <strong><label>{{__('section_background_color')}}</label></strong>
                                        <div class="color-picker" data-color="1">
                                            <input type="text" class="mini-color form-control" v-model="color1" data-color-no="1">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <strong><label>{{__('section_border_color')}}</label></strong>
                                        <div class="color-picker" data-color="2">
                                            <input type="text" class="mini-color form-control" v-model="color2" data-color-no="2">
                                        </div>
                                    </div>
                                </div>

                                <div class="m-b-xs">
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_top"> {{__('border_top')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_right"> {{__('border_right')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_bottom"> {{__('border_bottom')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_left"> {{__('border_left')}}</label></strong>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-white" data-dismiss="modal">{{ __('close') }}</button>
                                <button type="button" class="btn btn-primary save" data-dismiss="modal" @click="editSection()">{{ __('save') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal inmodal fade" id="editSectionGoods" tabindex="-1" role="dialog"  aria-hidden="true">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">{{ __('close') }}</span></button>
                                <h3>{{ __('edit_section') }}</h3>
                            </div>

                            <div class="modal-body">
                                <input type="hidden" name="section_index" v-bind:value="edit_goods_section_modal_index">
                                <input type="hidden" name="section_field" v-bind:value="edit_goods_section_modal_field">
                                <div class="items">

                                    <div v-if="!goods_services_modal_basic_mode">
                                        <div class="m-b-xs item" v-if="billMode == false && this.selected_document_type_value!=this.own_invoice_correction_pl_label">
                                            <strong>{{ __('vat_amount_and_gross_value_columns') }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="visible" name="vat_amount_and_gross_value_columns" v-bind:checked="vat_amount_and_gross_value_columns=='visible'" @click="vat_amount_and_gross_value_columns='visible'"> {{ __('visible') }}</label>
                                            <label><input type="radio" value="invisible" name="vat_amount_and_gross_value_columns" v-bind:checked="vat_amount_and_gross_value_columns=='invisible'" @click="vat_amount_and_gross_value_columns='invisible'"> {{ __('invisible') }}</label>
                                        </div>

                                        <div class="m-b-xs item">
                                            <strong>{{ __('information_about_discounts') }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="precise" name="information_about_discounts" v-bind:checked="information_about_discounts=='precise'" @click="information_about_discounts='precise'"> {{__('precise')}}</label>
                                            <label class="m-r-xs"><input type="radio" value="simplified" name="information_about_discounts" v-bind:checked="information_about_discounts=='simplified'" @click="information_about_discounts='simplified'"> {{__('simplified')}}</label>
                                            <label class="m-r-xs"><input type="radio" value="lack" name="information_about_discounts" v-bind:checked="information_about_discounts=='lack'" @click="information_about_discounts='lack'"> {{__('lack')}}</label>
                                        </div>

                                        <div class="m-b-xs item">
                                            <strong>{{ __('lp_column') }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="visible" name="lp_column" v-bind:checked="lp_column=='visible'" @click="lp_column='visible'"> {{ __('visible') }}</label>
                                            <label class="m-r-xs"><input type="radio" value="invisible" name="lp_column" v-bind:checked="lp_column=='invisible'" @click="lp_column='invisible'"> {{ __('invisible') }}</label>
                                        </div>

                                        <div class="m-b-xs item">
                                            <strong>{{ __('symbol_column') }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="visible" name="symbol_column" v-bind:checked="symbol_column=='visible'" @click="symbol_column='visible'"> {{ __('visible') }}</label>
                                            <label class="m-r-xs"><input type="radio" value="invisible" name="symbol_column" v-bind:checked="symbol_column=='invisible'" @click="symbol_column='invisible'"> {{ __('invisible') }}</label>
                                        </div>

                                        <div class="m-b-xs item">
                                            <strong>{{ __('pkwiu_column') }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="visible" name="pkwiu_column" v-bind:checked="pkwiu_column=='visible'" @click="pkwiu_column='visible'"> {{ __('visible') }}</label>
                                            <label class="m-r-xs"><input type="radio" value="invisible" name="pkwiu_column" v-bind:checked="pkwiu_column=='invisible'" @click="pkwiu_column='invisible'"> {{ __('invisible') }}</label>
                                        </div>

<!--                                        <div class="m-b-xs item">-->
<!--                                            <strong>{{ __('jm_column') }}:</strong><br>-->
<!--                                            <label class="m-r-xs"><input type="radio" value="visible" name="jm_column" v-bind:checked="jm_column=='visible'" @click="jm_column='visible'"> {{ __('visible') }}</label>-->
<!--                                            <label class="m-r-xs"><input type="radio" value="invisible" name="jm_column" v-bind:checked="jm_column=='invisible'" @click="jm_column='invisible'"> {{ __('invisible') }}</label>-->
<!--                                        </div>-->

                                        <div class="m-b-xs item" v-if="this.show_contract_description_option">
                                            <strong>{{ contract_description_label }}:</strong><br>
                                            <label class="m-r-xs"><input type="radio" value="visible" name="contract_description" v-bind:checked="contract_description=='visible'" @click="contract_description='visible'"> {{ __('visible') }}</label>
                                            <label class="m-r-xs"><input type="radio" value="invisible" name="contract_description" v-bind:checked="contract_description=='invisible'" @click="contract_description='invisible'"> {{ __('invisible') }}</label>
                                        </div>
                                    </div>
                                    <div class=" row m-b-xs">
				        <div class="col-md-4">
					    <strong>{{__('table_line_color')}}</strong><br>
                                            <div class="color-picker" data-color="3">
                                                <input type="text" class="mini-color form-control" v-model="color3" data-color-no="3">
                                            </div>
					</div>
				        <div class="col-md-4">
					    <strong>{{__('section_font_color')}}</strong><br>
                                            <div class="color-picker" data-color="4">
                                                <input type="text" class="mini-color form-control" v-model="color4" data-color-no="4">
                                            </div>
					</div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body" style="border-top: 1px solid #e9ecef;">
                                <h3>{{__('the_appearance_of_section')}}</h3>
                                <div class="row m-b-xs m-t">
                                    <div class="col-md-4">
                                        <strong><label>{{__('section_background_color')}}</label></strong>
                                        <div class="color-picker" data-color="1">
                                            <input type="text" class="mini-color form-control" v-model="color1" data-color-no="1">
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <strong><label>{{__('section_border_color')}}</label></strong>
                                        <div class="color-picker" data-color="2">
                                            <input type="text" class="mini-color form-control" v-model="color2" data-color-no="2">
                                        </div>
                                    </div>
                                </div>

                                <div class="m-b-xs">
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_top"> {{__('border_top')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_right"> {{__('border_right')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_bottom"> {{__('border_bottom')}}</label></strong>
                                    <strong><label class="m-r-xs"><input type="checkbox" v-model="border_left"> {{__('border_left')}}</label></strong>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-white" data-dismiss="modal">{{ __('close') }}</button>
                                <button type="button" class="btn btn-primary save" data-dismiss="modal" @click="editSectionGoods()">{{ __('save') }}</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="modal inmodal fade" id="addSection" tabindex="-1" role="dialog"  aria-hidden="true">
                    <div class="modal-dialog ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">{{ __('close') }}</span></button>
                                <h3>{{ __('add_section') }}</h3>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12 section-types">
                                        <label> <input type="radio" value="1" name="add_section_type" :checked="section_no==1" @click="section_no=1"> {{ __('whole_width') }} </label>
                                        <label> <input type="radio" value="2" name="add_section_type" :checked="section_no==2" @click="section_no=2"> {{ __('2columns') }} </label>
                                        <label> <input type="radio" value="3" name="add_section_type" :checked="section_no==3" @click="section_no=3"> {{ __('3columns') }} </label>
                                        <label v-if="allow_goods_services_section"> <input type="radio" value="4" name="add_section_type" :checked="section_no==4" @click="section_no=4"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_contract_section"> <input type="radio" value="5" name="add_section_type" :checked="section_no==5" @click="section_no=5"> {{ __('contract') }}</label>
                                        <label v-if="allow_goods_services_advance_section"> <input type="radio" value="6" name="add_section_type" :checked="section_no==6" @click="section_no=6"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_goods_services_advance_final_section"> <input type="radio" value="7" name="add_section_type" :checked="section_no==7" @click="section_no=7"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_before_advances_section"> <input type="radio" value="8" name="add_section_type" :checked="section_no==8" @click="section_no=8"> {{ __('before_advances') }}</label>
                                        <label v-if="allow_goods_services_advance_indirect_in_xxx_section"> <input type="radio" value="9" name="add_section_type" :checked="section_no==9" @click="section_no=9"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_goods_services_margin_advance_section"> <input type="radio" value="10" name="add_section_type" :checked="section_no==10" @click="section_no=10"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_goods_services_margin_final_section"> <input type="radio" value="11" name="add_section_type" :checked="section_no==11" @click="section_no=11"> {{ __('goods_services') }}</label>
                                        <label v-if="allow_before_advances_margin_section"> <input type="radio" value="12" name="add_section_type" :checked="section_no==12" @click="section_no=12"> {{ __('before_advances') }}</label>
                                        <label v-if="allow_goods_services_correction_section"> <input type="radio" value="13" name="add_section_type" :checked="section_no==13" @click="section_no=13"> {{ __('goods_services') }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-white" data-dismiss="modal">{{ __('close') }}</button>
                                <button id="add_section_btn" v-on:click="add_new_section(section_no)" type="button" class="btn btn-primary" data-dismiss="modal">{{ __('add') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-4">
                <div class="ibox">
                    <div class="ibox-title ibox-grey">
                        <h4>{{ __('available_variables') }}</h4>
                        <button-open-help-modal :help-name="'PMD-002'"/>
                    </div>
                    <div class="ibox-content variables_box" id="sidebar">
                        <div class="panel panel-default m-b-sm">
                            <div class="panel-heading">
                                <strong>{{ __('var_preview') }} [<span class="variables_name">{{this.variable_name}}</span>]</strong>
                            </div>
                            <div class="panel-body">
                                <div class="variables_description" v-html="this.variable_description"></div>
                                <p></p>
                                <small>{{__('choose_var_to_preview')}}</small>
                            </div>
                        </div>
                        <div class="variables">
                            <span v-for="(v, index) in variables_arr">
                                <span :class="(v.used?'bold':'')+' cp'" @click="getVariableDescription(v.id,v.name,false)" v-if="v.access" v-tooltip="__((v.used?'variable_used_in_template':''))">{{'['+v.name+'], '}}</span>
<!--                                <span v-if="!v.access" v-html="'<del>['+v.name+']</del>, '" class="tooltip-more" v-tooltip="__('variable_not_available_for_the_selected_document_type')"></span>-->
                            </span>
                        </div>
                    </div>
                </div>
                <div class="ibox">
                    <div class="ibox-title ibox-grey">
                        <h4>{{__('document_settings')}}</h4>
                        <button-open-help-modal :help-name="'PMD-003'"/>
                    </div>
                    <div class="ibox-content">
                        <div class="form-group row m-b-sm">
                            <div class="col-md-12">
                                <label><strong>{{ __('document_font') }}*</strong></label>
                                <select class="select2 form-control" name="font">
                                    <option v-for="(item, index) in document_fonts" :value="index" :selected="form_font == index">{{item}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import store from '../vuex/store'
    import {fetchTranslations} from "../services/TranslationsFetch";

    var translation_keys = ['gross_net_value', 'document_settings', 'document_font', 'table_line_color', 'section_font_color', 'the_appearance_of_section', 'section_border_color', 'section_background_color', 'border_top', 'border_right', 'border_bottom', 'border_left', 'move_down', 'move_up', 'goods_services', 'contract', '3columns', '2columns', 'whole_width', 'edit_section', 'available_variables', 'vat_amount_and_gross_value_columns', 'visible', 'invisible', 'precise', 'simplified', 'lack', 'close', 'information_about_discounts', 'lp_column', 'symbol_column', 'pkwiu_column', 'jm_column', 'add_section', 'add', 'preview', 'choose_var_to_preview', 'var_preview', 'variable_used_in_template', 'variable_not_available_for_the_selected_document_type', 'contact_description_variable', 'item_quantity', 'jm_variable', 'good_or_service_description_variable', 'quantity_variable', 'price_net_gross_variable', 'net_amount_variable_example', 'item_vat_rate_variable_example', 'total', 'including', 'document_net_amount', 'price_net_gross', 'item_vat_rate', 'symbol_variable', 'lp', 'symbol', 'pkwiu', 'jm', 'good_or_service_name_variable', 'pkwiu_variable', 'item_vat_amount_variable_example', 'gross_amount_variable_example', 'item_vat_amount', 'good_or_service_name', 'delete_element_?', 'it_will_not_be_possible_to_retrieve_it_later_!', 'overlay', 'template_name', 'foreign', 'pln', 'document_template', 'price_before_discount', 'discount%', 'price_net_gross_after_discount', 'price_before_discount_variable', 'discount%_variable', 'price_net_gross_after_discount_variable', 'rate', 'net', 'vat', 'gross', 'in_xxx_currency_example_label', 'in_pln_currency_example_label', 'invoice_own_pl', 'proforma_invoice_pl', 'price', 'bill_pl', 'price_after_discount', 'translation_language', 'exceptions_own_advance_invoice_pl_advance_payment', 'exceptions_own_advance_invoice_pl_indirect', 'exceptions_own_advance_invoice_pl_final', 'contact_order_data', 'billed_advances', 'document_number_advance_payment', 'value_after_accounting_for_billed_advances', 'before_advances', 'before_correction', 'after_correction', 'correction_amount', 'document_number_settled_advance_payment'];

    export default {
        name: 'documenttemplatesections',
        data: function () {
            return {
                color1: '#ffffff',
                color2: '#000000',
                color3: '#000000',
                color4: '#000000',
                color5: '#000000',
                border_top: false,
                border_bottom: false,
                border_left: false,
                border_right: false,
                colors: [
                    '#000000',
                    '#FFFFFF',
                    '#FF0000',
                    '#00FF00',
                    '#0000FF',
                    '#FFFF00',
                    '#00FFFF',
                    '#FF00FF',
                    '#C0C0C0',
                    '#808080',
                    '#800000',
                    '#808000',
                    '#008000',
                    '#800080',
                    '#008080',
                    '#000080'
                ],

                template_sections: [],
                section_no: 1,
                edit_section_modal_index: null,
                edit_section_modal_field: null,
                edit_goods_section_modal_index: null,
                edit_goods_section_modal_field: null,
                edit_goods_section_modal_border: false,
                vat_amount_and_gross_value_columns: 'invisible',
                information_about_discounts: 'lack',
                lp_column: 'invisible',
                symbol_column: 'invisible',
                pkwiu_column: 'invisible',
                jm_column: 'visible',
                contract_description: 'invisible',
                submit_disabled: false,
                possible_variables: [],
                overlays_to_select: [],
                document_types_to_select: [],
                show_currency_field: true,
                variables_arr: [],
                variable_description: '',
                variable_name: '',
                index_to_remove: null,
                overlay_id: null,
                name_obj: '',
                goods_services_default_data: {"jm_column": "visible", "contract_description": "invisible", "lp_column": "invisible", "pkwiu_column": "invisible", "symbol_column": "invisible", "information_about_discounts": "lack", "vat_amount_and_gross_value_columns": "invisible"},
                foreign_currency: false,
                allow_goods_services_section: false,
                allow_goods_services_advance_section: false,
                allow_goods_services_advance_final_section: false,
                allow_contract_section: false,
                allow_before_advances_section: false,
                allow_goods_services_advance_indirect_in_xxx_section: false,
                allow_goods_services_margin_advance_section: false,
                allow_goods_services_margin_final_section: false,
                allow_before_advances_margin_section: false,
                allow_goods_services_correction_section: false,
                selected_document_type_value: null,
                translationsToSelect: [],
                translationLanguage: null,
                document_type_id: null,
                billMode: false,
                section_types: [],
                goods_services_modal_basic_mode: false,
                show_contract_description_option: false,
                document_fonts: [],
                selected_currency: 'pln',
                show_font_color_in_modal: true
            }
        },
        methods: {
            setBorderStyle: function(template_section, field) {

                var style = '';
                var prefix = '';

                if(field == 'column1') {
                    prefix = 'column1_';
                }

                if(field == 'column2') {
                    prefix = 'column2_';
                }

                if(field == 'column3') {
                    prefix = 'column3_';
                }

                if(field == 'out') {
                    prefix = 'out_';
                }

                if(template_section[prefix+'background_color']) {
                    style += 'background-color:'+template_section[prefix+'background_color']+';';
                } else {
                    style += 'background-color:#ffffff;';
                }

                if(template_section[prefix+'border_top']) {
                    style += 'border-top: 1px solid '+template_section[prefix+'border_color']+';';
                }
                if(template_section[prefix+'border_bottom']) {
                    style += 'border-bottom: 1px solid '+template_section[prefix+'border_color']+';';
                }
                if(template_section[prefix+'border_left']) {
                    style += 'border-left: 1px solid '+template_section[prefix+'border_color']+';';
                }
                if(template_section[prefix+'border_right']) {
                    style += 'border-right: 1px solid '+template_section[prefix+'border_color']+';';
                }

                return style;

            },
            add_new_section: function (section_no) {
                this.submit_disabled = false;

                this.setBillMode();
                if (section_no == 1) {
                    this.template_sections.push({name: 'whole_width', type: this.section_types[section_no], goods_services_selected_list:[]});
                } else if (section_no == 2) {
                    this.template_sections.push({name: '2columns', type: this.section_types[section_no], goods_services_selected_list:[]});
                } else if (section_no == 3) {
                    this.template_sections.push({name: '3columns', type: this.section_types[section_no], goods_services_selected_list:[]});
                } else if (section_no == 4) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 5) {
                    this.template_sections.push({name: 'contract', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 6) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], goods_services_selected_list:[]});
                } else if (section_no == 7) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 8) {
                    this.template_sections.push({name: 'before_advances', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 9) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 10) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 11) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: (!this.billMode)?8:4, goods_services_colspan_counter2: (!this.billMode)?1:0});
                } else if (section_no == 12) {
                    this.template_sections.push({name: 'before_advances', type: this.section_types[section_no], goods_services_selected_list:[]});
                } else if (section_no == 13) {
                    this.template_sections.push({name: 'goods_services', type: this.section_types[section_no], 'goods_services': JSON.stringify(this.goods_services_default_data), 'goods_services_selected_list': this.goods_services_default_data, goods_services_colspan_counter: 7, goods_services_colspan_counter2: 2});
                } else {
                    return false;
                }
            },

            fillEditSectionModal: function (index, field) {

                if(field == 'column1') {
                    this.color1 = this.template_sections[index].column1_background_color;
                    this.color2 = this.template_sections[index].column1_border_color;
                    this.border_left = this.template_sections[index].column1_border_left;
                    this.border_right = this.template_sections[index].column1_border_right;
                    this.border_bottom = this.template_sections[index].column1_border_bottom;
                    this.border_top = this.template_sections[index].column1_border_top;
                }
                if(field == 'column2') {
                    this.color1 = this.template_sections[index].column2_background_color;
                    this.color2 = this.template_sections[index].column2_border_color;
                    this.border_left = this.template_sections[index].column2_border_left;
                    this.border_right = this.template_sections[index].column2_border_right;
                    this.border_bottom = this.template_sections[index].column2_border_bottom;
                    this.border_top = this.template_sections[index].column2_border_top;
                }
                if(field == 'column3') {
                    this.color1 = this.template_sections[index].column3_background_color;
                    this.color2 = this.template_sections[index].column3_border_color;
                    this.border_left = this.template_sections[index].column3_border_left;
                    this.border_right = this.template_sections[index].column3_border_right;
                    this.border_bottom = this.template_sections[index].column3_border_bottom;
                    this.border_top = this.template_sections[index].column3_border_top;
                }
                if(field == 'goods_services_text') {
                    this.color1 = this.template_sections[index].background_color;
                    this.color2 = this.template_sections[index].border_color;
                    this.color5 = this.template_sections[index].font_color;
                    this.border_left = this.template_sections[index].border_left;
                    this.border_right = this.template_sections[index].border_right;
                    this.border_bottom = this.template_sections[index].border_bottom;
                    this.border_top = this.template_sections[index].border_top;
                    this.show_font_color_in_modal = true;
                } else {
                    this.show_font_color_in_modal = false;
                }

                if(!this.color1) {
                    this.color1 = '#FFFFFF';
                }

                if(!this.color2) {
                    this.color2 = '#000000';
                }

                if(!this.color5) {
                    this.color5 = '#000000';
                }

                this.edit_section_modal_index = index;
                this.edit_section_modal_field = field;

                var val = null;
                if (field == 'column1') {
                    val = this.template_sections[index].column1;

                } else if (field == 'column2') {
                    val = this.template_sections[index].column2;
                } else if (field == 'column3') {
                    val = this.template_sections[index].column3;
                } else if (field == 'goods_services_text') {
                    val = this.template_sections[index].goods_services_text;
                }

                if (val == null) {
                    val = '';
                }

                $('#editSection').find('#editSectionVal').summernote('code', val);
            },
            fillEditSectionGoodsModal: function (index, field, basic_mode = false, show_contract_description_option = false) {
                this.goods_services_modal_basic_mode = basic_mode;
                this.show_contract_description_option = show_contract_description_option;
                this.edit_goods_section_modal_index = index;
                this.edit_goods_section_modal_field = field;
                var item = this.template_sections[index].goods_services;

                this.color1 = this.template_sections[index].out_background_color;
                this.color2 = this.template_sections[index].out_border_color;
                this.border_left = this.template_sections[index].out_border_left;
                this.border_right = this.template_sections[index].out_border_right;
                this.border_bottom = this.template_sections[index].out_border_bottom;
                this.border_top = this.template_sections[index].out_border_top;
                this.color3 = this.template_sections[index].table_border_color;
                this.color4 = this.template_sections[index].table_font_color;
                this.color5 = this.template_sections[index].font_color;

                if(!this.color1) {
                    this.color1 = '#FFFFFF';
                }
                if(!this.color2) {
                    this.color2 = '#000000';
                }
                if(!this.color3) {
                    this.color3 = '#000000';
                }
                if(!this.color4) {
                    this.color4 = '#000000';
                }
                if(!this.color5) {
                    this.color5 = '#000000';
                }

                if (item != null) {
                    item = JSON.parse(item);
                    this.vat_amount_and_gross_value_columns = item.vat_amount_and_gross_value_columns;
                    this.information_about_discounts = item.information_about_discounts;
                    this.lp_column = item.lp_column;
                    this.symbol_column = item.symbol_column;
                    this.pkwiu_column = item.pkwiu_column;
                    this.jm_column = item.jm_column;
                    this.contract_description = item.contract_description;
                } else {
                    this.vat_amount_and_gross_value_columns = 'invisible';
                    this.information_about_discounts = 'lack';
                    this.lp_column = 'invisible';
                    this.symbol_column = 'invisible';
                    this.pkwiu_column = 'invisible';
                    this.jm_column = 'visible';
                    this.contract_description = 'invisible';
                }
                this.setColors();
            },
            removeElement: function (index) {
                Vue.delete(this.template_sections, index);
                this.submit_disabled = false;
            },
            up: function (index) {
                this.submit_disabled = false;
                if (index > 0) {
                    var from = this.template_sections[index];
                    var to = this.template_sections[index - 1];
                    this.template_sections.splice(index - 1, 1, from);
                    this.template_sections.splice(index, 1, to);
                }
            },

            down: function (index) {
                this.submit_disabled = false;
                if (index < this.template_sections.length - 1) {
                    var from = this.template_sections[index];
                    var to = this.template_sections[index + 1];
                    this.template_sections.splice(index + 1, 1, from);
                    this.template_sections.splice(index, 1, to);
                }
            },
            checkUsedVariables: function () {
                for (var i = 0; i < this.variables_arr.length; i++) {
                    this.variables_arr[i].used = false;
                }

                for (var i = 0; i < this.template_sections.length; i++) {
                    if (this.template_sections[i].column1 != null) {
                        for (var j = 0; j < this.variables_arr.length; j++) {
                            if (this.template_sections[i].column1.includes('[' + this.variables_arr[j].name + ']')) {
                                this.variables_arr[j].used = true;
                            }
                        }
                    }

                    if (this.template_sections[i].column2 != null) {
                        for (var j = 0; j < this.variables_arr.length; j++) {
                            if (this.template_sections[i].column2.includes('[' + this.variables_arr[j].name + ']')) {
                                this.variables_arr[j].used = true;
                            }
                        }
                    }

                    if (this.template_sections[i].column3 != null) {
                        for (var j = 0; j < this.variables_arr.length; j++) {
                            if (this.template_sections[i].column3.includes('[' + this.variables_arr[j].name + ']')) {
                                this.variables_arr[j].used = true;
                            }
                        }
                    }

                    if (this.template_sections[i].goods_services_text != null) {
                        for (var j = 0; j < this.variables_arr.length; j++) {
                            if (this.template_sections[i].goods_services_text.includes('[' + this.variables_arr[j].name + ']')) {
                                this.variables_arr[j].used = true;
                            }
                        }
                    }
                }
            },
            editSection: function () {
                this.submit_disabled = false;
                var index = this.edit_section_modal_index;
                var field = this.edit_section_modal_field;
                var val = $('#editSection').find('#editSectionVal').summernote('code');

                var updated_item = this.template_sections[index];

                if (field == 'column1') {
                    updated_item.column1 = val;
                    updated_item.column1_background_color = this.color1;
                    updated_item.column1_border_color = this.color2;
                    updated_item.column1_border_top = this.border_top?1:0;
                    updated_item.column1_border_left = this.border_left?1:0;
                    updated_item.column1_border_right = this.border_right?1:0;
                    updated_item.column1_border_bottom = this.border_bottom?1:0;
                } else if (field == 'column2') {
                    updated_item.column2 = val;
                    updated_item.column2_background_color = this.color1;
                    updated_item.column2_border_color = this.color2;
                    updated_item.column2_border_top = this.border_top?1:0;
                    updated_item.column2_border_left = this.border_left?1:0;
                    updated_item.column2_border_right = this.border_right?1:0;
                    updated_item.column2_border_bottom = this.border_bottom?1:0;
                } else if (field == 'column3') {
                    updated_item.column3 = val;
                    updated_item.column3_background_color = this.color1;
                    updated_item.column3_border_color = this.color2;
                    updated_item.column3_border_top = this.border_top?1:0;
                    updated_item.column3_border_left = this.border_left?1:0;
                    updated_item.column3_border_right = this.border_right?1:0;
                    updated_item.column3_border_bottom = this.border_bottom?1:0;
                } else if (field == 'goods_services_text') {
                    updated_item.goods_services_text = val;
                    updated_item.background_color = this.color1;
                    updated_item.border_color = this.color2;
                    updated_item.border_top = this.border_top?1:0;
                    updated_item.border_left = this.border_left?1:0;
                    updated_item.border_right = this.border_right?1:0;
                    updated_item.border_bottom = this.border_bottom?1:0;
                    updated_item.font_color = this.color5;
                }

                this.template_sections.splice(index, 1, updated_item);
                this.checkUsedVariables();
            },
            editSectionSetBorder: function () {
                this.submit_disabled = false;
                var index = this.edit_section_modal_index;
                var field = this.edit_section_modal_field;

                var updated_item = this.template_sections[index];

                if (field == 'column1') {
                    updated_item.column1_border = val;
                } else if (field == 'column2') {
                    updated_item.column2_border = val;
                } else if (field == 'column3') {
                    updated_item.column3_border = val;
                } else if (field == 'goods_services_text') {
                    updated_item.goods_services_text_border = val;
                }
                this.template_sections.splice(index, 1, updated_item);
            },
            editSectionGoods: function () {
                this.submit_disabled = false;
                var goods = new Object();
                goods.vat_amount_and_gross_value_columns = this.vat_amount_and_gross_value_columns;
                goods.information_about_discounts = this.information_about_discounts;
                goods.lp_column = this.lp_column;
                goods.symbol_column = this.symbol_column;
                goods.pkwiu_column = this.pkwiu_column;
                goods.jm_column = 'visible';
                goods.contract_description = this.contract_description;

                var index = this.edit_goods_section_modal_index;
                var field = this.edit_goods_section_modal_field;
                var updated_item = this.template_sections[index];

                updated_item.out_background_color = this.color1;
                updated_item.out_border_color = this.color2;
                updated_item.out_border_top = this.border_top?1:0;
                updated_item.out_border_left = this.border_left?1:0;
                updated_item.out_border_right = this.border_right?1:0;
                updated_item.out_border_bottom = this.border_bottom?1:0;
                updated_item.table_border_color = this.color3;
                updated_item.table_font_color = this.color4;
                updated_item.font_color = this.color5;

                updated_item.goods_services_selected_list = goods;
                updated_item.goods_services = JSON.stringify(goods);

                var counters = this.countGoodsServicesColspans(updated_item);
                updated_item.goods_services_colspan_counter = counters[0];
                updated_item.goods_services_colspan_counter2 = counters[1];

                this.template_sections.splice(index, 1, updated_item);

            },
            countGoodsServicesColspans: function (item) {
                var counter = 13;
                var counter2 = 8;
                if (item != null) {
                    if(item.goods_services_selected_list.lp_column == 'invisible') {
                        counter--;
                        counter2--;
                    }
                    if(item.goods_services_selected_list.symbol_column == 'invisible') {
                        counter--;
                        counter2--;
                    }
                    if(item.goods_services_selected_list.pkwiu_column == 'invisible') {
                        counter--;
                        counter2--;
                    }
                    if(item.goods_services_selected_list.jm_column == 'invisible') {
                        counter--;
                        counter2--;
                    }
                    if(item.goods_services_selected_list.information_about_discounts == 'simplified') {
                        counter--;
                        counter2--;
                    }
                    if(item.goods_services_selected_list.information_about_discounts == 'lack') {
                        counter-=2;
                        counter2-=2;
                    }
                    if(item.goods_services_selected_list.vat_amount_and_gross_value_columns == 'invisible' & item.type != 'goods_services_correction') {
                        counter-=2;
                        counter2--;
                    } else if(this.foreign_currency & item.type != 'goods_services_correction') {
                        counter2++;
                    }
                    if(this.billMode) {
                        counter--;
                        counter2--;
                    }
                }
                return [counter, counter2];
            },
            editGoodsSectionSetBorder: function () {
                this.submit_disabled = false;
                var index = this.edit_goods_section_modal_index;
                var val = (this.$refs.editGoodsSectionBorderCheckbox.checked) ? 1 : 0;

                var updated_item = this.template_sections[index];

                updated_item.goods_services_border = val;

                this.edit_goods_section_modal_border = val == 1;

                this.template_sections.splice(index, 1, updated_item);
            },
            overlayChange: function (overlay_id) {
                if (overlay_id) {
                    this.$http.get(
                            this.overlay_allow_currency_url + '/' + overlay_id
                            ).then(response => {
                        this.show_currency_field = response.data.result
                    });
                } else {
                    this.show_currency_field = false;
                }
                this.overlay_id = overlay_id;
                this.fillDocumentTypesSelect();
            },
            variablesByType: function (document_type_id) {
                if (document_type_id) {

                    this.document_type_id = document_type_id;

                    this.variables_arr = [];

                    this.$http.get(
                            this.get_variables_url + '/' + document_type_id
                            ).then(response => {
                        var result = response.data;
                        for (var i = 0; i < result.length; i++) {
                            this.variables_arr.push({alias: result[i].alias, id: result[i].id, name: result[i].name, access: result[i].access, used: false});
                        }
                        this.checkUsedVariables();
                    });
                    this.variable_description = '';
                    this.setForeignCurrency(this.selected_currency != 'pln');
                }

            },
            getVariableDescription: function (id, name, insert_to_textarea) {
                this.variable_name = name;
                var document_type_id = this.document_type_id;
                this.$http.get(
                        this.get_variable_description_url + '/' + id + '/' + document_type_id,
                        ).then(response => {
                    this.variable_description = response.data;
                });
                if (insert_to_textarea) {
                    var textarea_val = $('#editSection').find('#editSectionVal').summernote('code');
                    $('#editSection').find('#editSectionVal').summernote('code', textarea_val + ' [' + name + ']');
                }
            },
            fillDocumentTypesSelect: function () {
                this.document_types_to_select = [];
                if (this.overlay_id) {
                    var document_types = JSON.parse(this.document_types);
                    for (var i = 0; i < document_types.length; i++) {
                        this.document_types_to_select.push({id: document_types[i].id, name: document_types[i].trans_type_name});
                        if(document_types[i].id == this.form_document_types_id) {
                            this.selected_document_type_value = document_types[i].trans_type_name;
                        }
                    }
                }
            },
            changeNameObj: function (name_obj) {
                this.name_obj = name_obj;
            },
            setDeleteSwal: function () {
                var vue_app = this;
                $('.icon-delete2').click(function () {
                    swal({
                        title: vue_app.__('delete_element_?'),
                        text: vue_app.__('it_will_not_be_possible_to_retrieve_it_later_!'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: vue_app.__('delete'),
                        cancelButtonText: vue_app.__('cancel'),
                        closeOnConfirm: true
                    }, function () {
                        vue_app.removeElement(vue_app.index_to_remove);
                    });
                });
            },
            setForeignCurrency: function(val){
                this.foreign_currency = val;
                if(this.proforma_invoice_pl_label == this.selected_document_type_value) {
                    this.foreign_currency = false;
                }
            },
            addDefaultSection: function(sectionId) {
                var exists = false;
                for(var i=this.template_sections.length-1; i>=0; i--) {
                    if(this.template_sections[i].type == this.section_types[sectionId]) {
                        exists = true;
                        break;
                    }
                }
                if(!exists) {
                    this.add_new_section(sectionId);
                }
            },
            documentTypeChange: function(val, after_change_document_type) {

                this.selected_document_type_value = val;
                this.specificSectionAccess(after_change_document_type);

                this.setBillMode();
                this.setForeignCurrency(this.selected_currency != 'pln');
            },
            translationLanguageChange: function(val){
                this.translationLanguage = val;
            },
            getTranslation: function(str){
                var translatedStr = '';
                if(this.translationLanguage) {
                    translatedStr = ' ' + str;
                    if(this.translationsToSelect[this.translationLanguage] != null){
                        if(this.translationsToSelect[this.translationLanguage].translations[str]){
                            translatedStr = '<span class="translation-string">(' + this.translationsToSelect[this.translationLanguage].translations[str] + ')</span>';
                        }
                    }
                }
                return translatedStr;
            },
            specificSectionAccess: function(after_change_document_type){
                this.axios.post(this.specific_section_route, {document_type: this.selected_document_type_value, foreign_currency: this.foreign_currency})
                .then(response => {
                    this.allow_goods_services_section = false;
                    this.allow_contract_section = false;
                    this.allow_goods_services_advance_section = false;
                    this.allow_goods_services_advance_final_section = false;
                    this.allow_before_advances_section = false;
                    this.allow_goods_services_advance_indirect_in_xxx_section = false;
                    this.allow_goods_services_margin_advance_section = false;
                    this.allow_goods_services_margin_final_section = false;
                    this.allow_before_advances_margin_section = false;
                    this.allow_goods_services_correction_section = false;

                    if(response.data.includes('goods_services')) {
                        this.allow_goods_services_section = true;
                    }
                    if(response.data.includes('contract')) {
                        this.allow_contract_section = true;
                    }
                    if(response.data.includes('goods_services_advance')) {
                        this.allow_goods_services_advance_section = true;
                    }
                    if(response.data.includes('goods_services_advance_final')) {
                        this.allow_goods_services_advance_final_section = true;
                    }
                    if(response.data.includes('before_advances')) {
                        this.allow_before_advances_section = true;
                    }
                    if(response.data.includes('goods_services_advance_indirect_in_xxx')) {
                        this.allow_goods_services_advance_indirect_in_xxx_section = true;
                    }
                    if(response.data.includes('goods_services_margin_advance')) {
                        this.allow_goods_services_margin_advance_section = true;
                    }
                    if(response.data.includes('goods_services_margin_final')) {
                        this.allow_goods_services_margin_final_section = true;
                    }
                    if(response.data.includes('before_advances_margin')) {
                        this.allow_before_advances_margin_section = true;
                    }
                    if(response.data.includes('goods_services_correction')) {
                        this.allow_goods_services_correction_section = true;
                    }

                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_section, 4, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_contract_section, 5, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_advance_section, 6, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_advance_final_section, 7, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_before_advances_section, 8, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_advance_indirect_in_xxx_section, 9, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_margin_advance_section, 10, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_margin_final_section, 11, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_before_advances_margin_section, 12, after_change_document_type);
                    this.showOrHideSpecificSectionsByAccess(this.allow_goods_services_correction_section, 13, after_change_document_type);

                });
            },

            showOrHideSpecificSectionsByAccess: function(access, section_no, after_change_document_type){
                if(access) {
                    if(['create', 'copy'].includes(this.mode)) {
                        this.addDefaultSection(section_no);
                    }
                } else {
                    for(var i=this.template_sections.length-1; i>=0; i--) {
                        if(this.template_sections[i].type == this.section_types[section_no]) {
                            this.removeElement(i);
                        } else if(after_change_document_type) {
                            this.template_sections[i].out_background_color = '#FFFFFF';
                            this.template_sections[i].out_border_color = '#000000';
                            this.template_sections[i].out_border_top = 0;
                            this.template_sections[i].out_border_bottom = 0;
                            this.template_sections[i].out_border_right = 0;
                            this.template_sections[i].out_border_left = 0;
                            this.template_sections[i].table_border_color = '#000000';
                            this.template_sections[i].table_font_color = '#000000';
                            this.template_sections[i].font_color = '#000000';
                            this.template_sections[i].background_color = '#FFFFFF';
                            this.template_sections[i].border_top = false;
                            this.template_sections[i].border_bottom = false;
                            this.template_sections[i].border_right = false;
                            this.template_sections[i].border_left = false;
                        }
                    }
                }
            },
            setBillMode: function(){
                this.billMode = this.selected_document_type_value==this.bill_pl_label | this.selected_document_type_value==this.advance_invoice_margin_pl_advance_payment_label | this.selected_document_type_value==this.advance_invoice_margin_pl_final_label | this.selected_document_type_value==this.invoice_margin_pl_label;
                for(var i=this.template_sections.length-1; i>=0; i--) {
                    var updated_item = this.template_sections[i];
                    if(this.template_sections[i].goods_services!=null) {
                        var goods = JSON.parse(this.template_sections[i].goods_services);
                        if(this.billMode) {
                            goods.vat_amount_and_gross_value_columns = "invisible";
                        }
                        updated_item.goods_services_selected_list = goods;
                        updated_item.goods_services = JSON.stringify(goods);
                    }
                    var counters = this.countGoodsServicesColspans(updated_item);
                    updated_item.goods_services_colspan_counter = counters[0];
                    updated_item.goods_services_colspan_counter2 = counters[1];
                    this.template_sections.splice(i, 1, updated_item);
                }
            },
            setColors: function(){
                $('.mini-color').each(function () {
                    var c = $(this).val();
                    if(jQuery.trim(c) == '') {
                        c = 'transparent';
                    }
                    $(this).minicolors('value',c);
                });
            }
        },

        mounted: function () {
            fetchTranslations(store, translation_keys);
            this.section_types[1]='whole_width';
            this.section_types[2]='2columns';
            this.section_types[3]='3columns';
            this.section_types[4]='goods_services';
            this.section_types[5]='contract';
            this.section_types[6]='goods_services_advance';
            this.section_types[7]='goods_services_advance_final';
            this.section_types[8]='before_advances';
            this.section_types[9]='goods_services_advance_indirect_in_xxx';
            this.section_types[10]='goods_services_margin_advance';
            this.section_types[11]='goods_services_margin_final';
            this.section_types[12]='before_advances_margin';
            this.section_types[13]='goods_services_correction';

            this.document_fonts = JSON.parse(this.fonts);

            var get_variables_url = this.get_variables_url;
            var get_variable_description_url = this.get_variable_description_url;
            var form_submit_route = this.form_submit_route;
            var preview_url = this.preview_url;

            this.translationsToSelect=JSON.parse(this.translations);
            this.translationLanguage = this.form_translation_language;

            this.document_type_id = this.form_document_types_id;

            if(this.mode != 'create') {
                this.setForeignCurrency(this.selected_currency != 'pln');
            }

            var overlays = JSON.parse(this.overlays);

            for (var i = 0; i < overlays.length; i++) {
                this.overlays_to_select.push({id: overlays[i].id, name: overlays[i].name});
            }

            this.name_obj = this.form_name_obj;
            this.overlay_id = this.form_document_overlays_id;
            this.fillDocumentTypesSelect();
            if(this.mode == 'edit'){
                this.setBillMode()
            }
            this.overlayChange(this.form_document_overlays_id);

            var sections = JSON.parse(this.sections);

            if (sections != null) {
                for (var i = 0; i < sections.length; i++) {

                    var goods_services_obj = JSON.parse(sections[i].goods_services);

                    var section_name = sections[i].type;

                    if(section_name == 'goods_services_advance' | section_name == 'goods_services_advance_final' | section_name == 'goods_services_advance_indirect_in_xxx' | section_name == 'goods_services_margin_advance' | section_name == 'goods_services_margin_final' | section_name == 'goods_services_correction') {
                        section_name = 'goods_services';
                    }

                    if(section_name == 'before_advances_margin') {
                        section_name = 'before_advances';
                    }

                    var section = {
                        name: section_name,
                        type: sections[i].type,
                        column1: sections[i].column1,
                        column1_border: sections[i].column1_border,
                        column2: sections[i].column2,
                        column2_border: sections[i].column2_border,
                        column3: sections[i].column3,
                        column3_border: sections[i].column3_border,
                        goods_services: sections[i].goods_services,
                        goods_services_border: sections[i].goods_services_border,
                        goods_services_selected_list: (goods_services_obj == null) ? this.goods_services_default_data : goods_services_obj,
                        goods_services_colspan_counter: 0,
                        goods_services_colspan_counter2: 0,
                        goods_services_text: sections[i].goods_services_text,
                        goods_services_text_border: sections[i].goods_services_text_border,
                        background_color: sections[i].background_color,
                        border_color: sections[i].border_color,
                        border_top: sections[i].border_top,
                        border_bottom: sections[i].border_bottom,
                        border_left: sections[i].border_left,
                        border_right: sections[i].border_right,
                        column1_background_color: sections[i].column1_background_color,
                        column1_border_color: sections[i].column1_border_color,
                        column1_border_top: sections[i].column1_border_top,
                        column1_border_bottom: sections[i].column1_border_bottom,
                        column1_border_left: sections[i].column1_border_left,
                        column1_border_right: sections[i].column1_border_right,
                        column2_background_color: sections[i].column2_background_color,
                        column2_border_color: sections[i].column2_border_color,
                        column2_border_top: sections[i].column2_border_top,
                        column2_border_bottom: sections[i].column2_border_bottom,
                        column2_border_left: sections[i].column2_border_left,
                        column2_border_right: sections[i].column2_border_right,
                        column3_background_color: sections[i].column3_background_color,
                        column3_border_color: sections[i].column3_border_color,
                        column3_border_top: sections[i].column3_border_top,
                        column3_border_bottom: sections[i].column3_border_bottom,
                        column3_border_left: sections[i].column3_border_left,
                        column3_border_right: sections[i].column3_border_right,
                        out_background_color: sections[i].out_background_color,
                        out_border_color: sections[i].out_border_color,
                        out_border_top: sections[i].out_border_top,
                        out_border_bottom: sections[i].out_border_bottom,
                        out_border_left: sections[i].out_border_left,
                        out_border_right: sections[i].out_border_right,
                        table_border_color: sections[i].table_border_color,
                        table_font_color: sections[i].table_font_color,
                        font_color: sections[i].font_color
                    };

                    var counters = this.countGoodsServicesColspans(section);
                    section.goods_services_colspan_counter = counters[0];
                    section.goods_services_colspan_counter2 = counters[1];

                    this.template_sections.push(section);

                }
            }

            if (this.mode == 'copy' & this.wrong_validation == 0) {
                this.submit_disabled = true;
            }

            this.variablesByType(this.form_document_types_id);

            var vue_app = this;

            $(function () {
                $('.mini-color').each(function () {
                    $(this).minicolors({
                        control: $(this).attr('data-control') || 'hue',
                        defaultValue: $(this).attr('data-defaultValue') || '',
                        format: $(this).attr('data-format') || 'hex',
                        keywords: $(this).attr('data-keywords') || '',
                        inline: $(this).attr('data-inline') === 'true',
                        letterCase: $(this).attr('data-letterCase') || 'lowercase',
                        opacity: $(this).attr('data-opacity'),
                        position: $(this).attr('data-position') || 'bottom',
                        swatches: $(this).attr('data-swatches') ? $(this).attr('data-swatches').split('|') : [],
                        change: function (hex, opacity) {
                            var log;
                            try {
                                log = hex ? hex : 'transparent';
                                if (opacity)
                                    log += ', ' + opacity;
                            } catch (e) {
                            }
                        },
                        theme: 'default',
                        value: "#cccccc"
                    });
                });

                $('a[data-target="#editSectionGoods"],a[data-target="#editSection"]').click(function(){
                    vue_app.setColors();
                });
                $('.minicolors-panel').mouseleave(function () {
                    var input = $(this).closest('.color-picker').find('input');
                    var color_no = input.data('color-no');


                    if(color_no == 1) {
                        vue_app.color1 = input.val();
                    } else if(color_no == 2) {
                        vue_app.color2 = input.val();
                    } else if(color_no == 3) {
                        vue_app.color3 = input.val();
                    } else if(color_no == 4) {
                        vue_app.color4 = input.val();
                    } else if(color_no == 5) {
                        vue_app.color5 = input.val();
                    }
                });

                $('.summernote').summernote({
                    lang: "pl-PL",
                    toolbar: [
                        ['style', ['bold', 'italic', 'underline', 'clear']],
                        ['font', ['strikethrough', 'superscript', 'subscript']],
                        ['fontsize', ['fontsize']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                    ]
                });

                $('#preview').click(function () {
                    $('#add_document_template_form').attr('action', preview_url);
                    $('#add_document_template_form').attr("target", "_blank");
                    $('#add_document_template_form').submit();
                });
                vue_app.setDeleteSwal();
                $('#add_section_btn').click(function () {
                    vue_app.setDeleteSwal();
                });
                $('#submit').click(function () {
                    $('#add_document_template_form').attr('action', form_submit_route);
                    $('#add_document_template_form').removeAttr("target");
                    $('#add_document_template_form').submit();
                });
                if(['create', 'copy'].includes(vue_app.mode)){
                    vue_app.documentTypeChange($('[name="document_types_id"]').find('option:selected').text(), false);
                }


                $(".select2").select2();
                $('[name="document_types_id"]').change(function () {
                    vue_app.variablesByType($(this).val());
                    vue_app.documentTypeChange($(this).find('option:selected').text(), true);
                });
                $('[name="document_overlays_id"]').change(function () {
                    vue_app.overlayChange($(this).val());
                });
                $('[name="currency"]').change(function () {
                    vue_app.selected_currency = $('[name="currency"]').val();
                    vue_app.setForeignCurrency(vue_app.selected_currency!='pln');
                    vue_app.specificSectionAccess(false);
                    for(var i =0; i<vue_app.template_sections.length;i++) {
                        if(vue_app.template_sections[i].name == 'goods_services' | vue_app.template_sections[i].name == 'contract') {
                            var counters = vue_app.countGoodsServicesColspans(vue_app.template_sections[i]);
                            vue_app.template_sections[i].goods_services_colspan_counter = counters[0];
                            vue_app.template_sections[i].goods_services_colspan_counter2 = counters[1];
                        }
                    }
                });
                vue_app.selected_currency = $('[name="currency"]').val();
                vue_app.setForeignCurrency(vue_app.selected_currency!='pln');
                vue_app.specificSectionAccess(false);
                $('[name="translation_language"]').change(function () {
                    vue_app.translationLanguageChange($(this).val());
                });
            });

        },

        props: [
         'is_sa',
         'old_activate_template',
         'sections',
         'mode',
         'wrong_validation',
         'variables',
         'get_variables_url',
         'get_variable_description_url',
         'form_submit_route',
         'preview_url',
         'validation_message_name_obj',
         'validation_message_document_types_id',
         'validation_message_document_overlays_id',
         'validation_message_currency',
         'form_name_obj',
         'form_document_types_id',
         'form_currency',
         'form_document_overlays_id',
         'overlays',
         'document_types',
         'overlay_allow_currency_url',
         'document_templates_route',
         'foreign_label',
         'pln_label',
         'bill_pl_label',
         'invoice_own_pl_label',
         'proforma_invoice_pl_label',
         'disabled_inputs',
         'form_translation_language',
         'form_font',
         'translations',
         'specific_section_route',
         'advance_invoice_margin_pl_advance_payment_label',
         'advance_invoice_margin_pl_final_label',
         'own_invoice_correction_pl_label',
         'invoice_margin_pl_label',
         'contract_description_label',
         'fonts'
        ]
    }
</script>
<style>
    .border0{border: 1px dashed #f1f1f1;}
    .border1{border: 1px solid; border-color:inherit;}
    .move[disabled="disabled"]{display:none;}
    @media (min-width: 992px){
        .modal-md {
            max-width: 800px;
        }
    }
    .bold{font-weight:bold}

    .invoicetable {width:100%;border-color:black}
    .invoicetable tr{border-color:inherit}
    .invoicetable td,.invoicetable th{border:1px solid;padding:3px 4px;text-align:center;}
    .invoicetable tbody, .invoicetable td, .invoicetable th{border-color:inherit;background-color:transparent}
    .no-border-left{border-left: none!important;}
    .no-border-bottom{border-bottom: none!important;}
    .no-border-top{border-top: none!important;}
    .no-border-right{border-right: none!important;}
    .float-right{float:right}
    .v-top{vertical-align:top}
    .p10{padding:10px!important}
    .keep_height{height:10px;}
    .pl0{padding-left:0!important}
    .pt0{padding-top:0!important}
    .emptyrow{
        position: relative;
        background-color: white;
    }
    .border-left2{position:relative;}
    .border-left2 span:not(.translation-string) {
        background-color: black;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 1px;
    }
    .translation-string {
        display: block;
        font-size: 9px;
    }
    .inline .translation-string {display:inline}
    .cp{cursor:pointer;}
    .section-types label{display:block}
    .uppercase{text-transform:uppercase}
    .w70{width: 70px;}
    .w50{width: 50px;}
    .w90{width: 90px;}
    .tooltip {
      display: block !important;
      z-index: 10000;
    }

    .tooltip .tooltip-inner {
      background: #495966;
      color: white;
      border-radius: 4px;
      padding: 5px 10px 4px;
    }

    .tooltip .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }

    .tooltip[x-placement^="top"] {
      margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
      margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
      margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
      margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }

    .tooltip.popover .popover-inner {
      background: #f9f9f9;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .tooltip.popover .popover-arrow {
      border-color: #f9f9f9;
    }

    .tooltip[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }

    .color-input {
        border-radius: 0;
        border: 1px solid #c9ccd0;
    }
    .color-input::placeholder{color:white}
    th.good_or_service_name{width:350px;}
    table a.btn-default{color:#383838!important}

    a[data-target="#editSectionGoods"] {color:black!important}
    .minicolors-theme-default .minicolors-input {
        padding: 5px !important;
        width: 100% !important;
        height: auto !important;
    }
    .minicolors-theme-default.minicolors {
        width: 100% !important;
    }
    .minicolors-theme-default .minicolors-swatch{display:none!important}
    [aria-label="Outdent (⌘+[)"], [aria-label="Indent (⌘+])"]{display:none!important}
</style>
